<template>
  <div class="test-page-view">
    <h1>Тестовая страница</h1>
    <p>Это тестовая пустая страница</p>
  </div>
</template>

<script>
export default {
  name: 'TestPageView',
}
</script>

<style scoped>
.test-page-view {
  padding: 20px;
  color: #fff;
}

h1 {
  margin: 0 0 10px 0;
}

p {
  margin: 0;
}
</style>

